import { NormalizedToken } from '../model';

const ONRAMP_TOKEN_DATA: Record<string, Record<string, string>> = {
  bsc: {
    usdt: 'usdt_bsc',
    usdc: 'usdc_bsc',
    bnb: 'bnb_bsc',
  },
  eth: {
    eth: 'eth',
  },
  btc: {
    btc: 'btc',
  },
};

export const buildOnrampPaymentToken = ({ symbol, networkId }: NormalizedToken) => {
  const crypto = ONRAMP_TOKEN_DATA[networkId.toLowerCase()]?.[symbol.toLowerCase()];

  if (!crypto) {
    throw new Error(`Unsupported token: ${symbol} on network ${networkId}`);
  }

  if (!crypto) {
    throw new Error('Cannot build on ramp token data');
  }

  return {
    onlyCryptos: [crypto.toLowerCase()],
    onlyCryptoNetworks: [networkId.toLowerCase()],
  };
};
